/**
 * Формат проведения
 */
export enum EventType {
  fullTime = 'fullTime',
  distance = 'distance',
}
